const config = {
  localurl: process.env.REACT_APP_LOCAL_URL,
  environmentName: process.env.NODE_ENV,
  sentryDsn: process.env.REACT_APP_SENTRY_DSN,
};
export default config;
